import { render } from "./SideBarMenu.vue?vue&type=template&id=4b50f017&scoped=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"

import "./SideBarMenu.vue?vue&type=style&index=0&id=4b50f017&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/zmen-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b50f017"]])

export default __exports__